import { UserRoles } from '@/enums';
import { MarketingFund } from '@/modules/marketing-fund/types';

const access_roles = {
  [MarketingFund.Pages.MARKETING_FUND]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.PURCHASING_MANAGER,
    UserRoles.Internal.SALE_MANAGER,
    UserRoles.Internal.MARKETER,
    UserRoles.Internal.SALE_MANAGER_FULL_PRICE,
  ],
};

export default access_roles;
